import React from 'react';
import ProfilePage from '../ProfilePage';

export default function SettingsProfile() {
  return (
    <div className="bg-background-light dark:bg-background-dark min-h-screen">
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 max-w-5xl">
        <h1 className="text-2xl font-bold mb-4 text-text-dark dark:text-text-light">Profil Yönetimi</h1>
        <div className="panel rounded-xl shadow p-2 md:p-4">
          <ProfilePage />
        </div>
      </main>
    </div>
  );
}
